import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/Restaurant.css";
import dishesData from '../assets/dishes2.json';

const Restaurant = () => {
  const { id } = useParams();
  const [restaurant, setRestaurant] = useState(null);
  const dishList = dishesData;

  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const basePath = isLocalhost ? "" : "https://webdev.cse.buffalo.edu/hci/teams/indecisive";

  useEffect(() => {
    const dataUrl = isLocalhost
      ? "/data/restaurants.json"
      : "https://webdev.cse.buffalo.edu/hci/teams/indecisive/data/restaurants.json";

    fetch(dataUrl)
      .then((res) => res.json())
      .then((data) => {
        const rest = data.restaurants.find(r => r.id === parseInt(id, 10));
        if (rest) {
          rest.logo = `${basePath}${rest.logo}`;
          rest.menu = rest.menu.map(meal => ({
            ...meal,
            image: `${basePath}${meal.image}`,
          }));
          setRestaurant(rest);
        } else {
          setRestaurant(null);
        }
      })
      .catch((error) => {
        console.error("Failed to load restaurant data:", error);
      });
  }, [id]);

  if (!restaurant) return <div>Restaurant not found.</div>;

  return (
    <div className="restaurant-container">
      <div className="restaurant-header">
        <div className="restaurant-logo">
          <img
            src={restaurant.logo} alt="Restaurant Logo"
            style={{
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>

        <div className="restaurant-info">
          <h2>{restaurant.name}</h2>
          <p><strong>Open:</strong> {restaurant.hours}</p>
        </div>

        <div className="restaurant-contact">
          <p><strong>Phone:</strong> {restaurant.phone}</p>
          <p><strong>Address:</strong> {restaurant.address}</p>
        </div>
      </div>

      <div className="meal-grid">
        {restaurant.menu.map((meal) => {
          const cleanMealName = meal.name.replace(/\s*\([^)]*\)\s*/g, "").trim();
          const dish = dishList.find(dishItem => {
            const dishTitle = dishItem.title.trim();
            const dishRestaurant = dishItem.restaurantName;
            return (cleanMealName.startsWith(dishTitle) || dishTitle.startsWith(cleanMealName)) 
                    && dishRestaurant === restaurant.name;
          }) || dishList.find(dishItem => dishItem.id === meal.dishId);

          const dishId = dish?.id || null;

          return (
            <div key={meal.id} className="meal-card">
              <Link to={dishId ? `/dish/${dishId}` : `/dish-not-found`}>
                <img src={meal.image} alt={meal.name} className="meal-image" />
                <p className="meal-name">{meal.name}</p>
                <p className="meal-price">{meal.price}</p>
              </Link>
            </div>
          );
        })}
      </div>

      {restaurant.note && (
        <div className="restaurant-note">
          <p><strong>Note:</strong> {restaurant.note}</p>
        </div>
      )}
    </div>
  );
};

export default Restaurant;
